<template>
  <div class="account-page section-main__warp">
    <ioc-table ref="crud" v-model="account" :data="tableData" :option="option" :page="page"
      @search-change="handleSearchChange" @search-reset="handleSearchReset" @size-change="handleSizeChange"
      @current-change="handleCurrentChange" @refresh-change="refreshChange" @selection-change="handleSelectionChange">
      <template slot="roleView">
        <p class="tab-item" v-for="(role, index) in reservedAccount" :key="index">
          {{ role.accountGroupName }}
        </p>
      </template>
      <template slot="menuLeft">
        <el-button v-auth="'/account/index:add'" type="primary" size="small" class="iss-operation-button"
          icon="el-icon-plus" @click="handleAddAccount">
          新增
        </el-button>
        <el-button v-auth="'/account/index:delete'" type="primary" size="small" icon="el-icon-delete"
          class="iss-operation-button" @click="handelDelAccounts">
          批量删除
        </el-button>
      </template>
      <template slot="menu" slot-scope="scope">
        <el-tooltip class="item" effect="dark" content="详情" placement="top" popper-class="tooltip-draw">
          <el-button type="text" icon="iconfont icon-Detail" @click="handleView(scope.row, scope.index)"></el-button>
        </el-tooltip>
        <el-tooltip class="item" effect="dark" content="重置密码" placement="top" popper-class="tooltip-draw">
          <el-button v-auth="'/account/index:resetPassword'" type="text" :disabled="scope.row.status !== 1"
            icon="iconfont icon-mimashezhi" @click="handleEditPwd(scope.row, scope.index)"></el-button>
        </el-tooltip>
        <el-tooltip class="item" effect="dark" content="编辑" placement="top" popper-class="tooltip-draw">
          <el-button v-auth="'/account/index:update'" type="text" :disabled="scope.row.status !== 1"
            icon="iconfont icon-xiugai" @click="handleEdit(scope.row, scope.index)"></el-button>
        </el-tooltip>
        <el-tooltip class="item" effect="dark" content="删除" placement="top" popper-class="tooltip-draw">
          <el-button v-auth="'/account/index:delete'" type="text" :disabled="!scope.row.dataType"
            icon="iconfont icon-shanchu" @click="handleDel(scope.row, scope.index)"></el-button>
        </el-tooltip>
        <el-tooltip class="item" effect="dark" content="设置权限" placement="top" popper-class="tooltip-draw">
          <el-button v-auth="'/account/index:setPermission'" type="text" :disabled="scope.row.status !== 1"
            icon="iconfont icon-zhanghushezhi" @click="handleSet(scope.row)"></el-button>
        </el-tooltip>
        <el-tooltip v-if="scope.row.status === 3" class="item" effect="dark" content="解锁" placement="top"
          popper-class="tooltip-draw">
          <el-button type="text" icon="iconfont icon-Unlock" @click="unlock(scope.row)"></el-button>
        </el-tooltip>
      </template>
      <template slot="accountNumber" slot-scope="scope">
        <el-button type="text" @click="handleView(scope.row, scope.index)">
          {{ scope.row.accountNumber | ellipsis(32) }}
        </el-button>
      </template>
      <template slot="status" slot-scope="scope">
        <el-switch v-auth="'/account/index:active'" v-model="scope.row.status" :disabled="scope.row.status === 3"
          :active-value="1" :inactive-value="scope.row.status == 3 ? 3 : 2"
          @change="handleUpdateStatus(scope.row)"></el-switch>
        {{ scope.row.$status }}
      </template>
    </ioc-table>
    <!-- 重置密码 -->
    <el-dialog title="重置密码" v-dialogDrag :visible.sync="dialogVisible" width="500px">
      <ioc-form ref="resetPass" v-model="resetForm" :option="passOption" @submit="onSubmitPwd"></ioc-form>
    </el-dialog>
    <!-- 新增/编辑/详情账户 -->
    <appPanel :width="pageStates == 'view' ? 700 : 840" class="app-panel" :isExpand="showAccountPanel" :title="pageStates == 'add' ? '新增账户' : pageStates == 'edit' ? '编辑账户' : '账户详情'
      " @cancel="handleCloseAccountPanel">
      <accountPanel ref="refAccountPanel" :pageStates="pageStates" :isEditAccoutType="isEditAccoutType" @save-people-info="savePeopleInfo" />
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleCloseAccountPanel" type="info" :loading="subLoading">
          {{ pageStates == "view" ? "关闭" : "取消" }}
        </el-button>
        <el-button v-if="pageStates != 'view'" type="primary" :loading="subLoading" @click="handleSaveAccountPanel">
          {{ subLoading ? "提交中" : "确定" }}
        </el-button>
      </span>
    </appPanel>
    <group-transfer ref="transferDialog" @refreshData="refreshChange(page)"></group-transfer>
  </div>
</template>
<script>
import { api } from "../api";
import sha256 from "@src/common/lib/sha";
import accountPanel from "../components/accountPanel";
import tableOption from "../const/crud/account";
import utils from "@src/common/utils";
import { Bus } from "$utils";
import groupTransfer from "../components/group-transferCopy.vue";
import appPanel from "@src/components/business/app-panel/index";
export default {
  components: {
    accountPanel,
    appPanel,
    groupTransfer,
  },
  data() {
    return {
      isEditAccoutType: false,
      pageStates: "add",
      showAccountPanel: false,
      codeType: 1,
      showAuthPanel: false,
      accountGroupList: [],
      reservedAccount: [],
      accountNumber: "",
      passOption: {
        submitText: this.$t("base.button.save"),
        emptyText: this.$t("base.button.reset"),
        column: [
          {
            span: 24,
            label: this.$t("base.label.newPwd"),
            type: "password",
            prop: "pass",
            rules: [
              {
                required: true,
                message: this.$t("base.message.newPwd"),
                trigger: "blur",
              },
              {
                min: 6,
                max: 6,
                message: "密码长度为6个字符",
                trigger: ["blur", "change"],
              },
              { validator: this.validatePwd, trigger: ["blur"] },
            ],
            placeholder: this.$t("base.placeholder.newPwd"),
          },
          {
            span: 24,
            label: this.$t("base.label.confirmPwd"),
            type: "password",
            prop: "againPass",
            tipPlacement: "left",
            rules: [
              {
                required: true,
                message: this.$t("base.message.confirmPwd"),
                trigger: "blur",
              },
              { validator: this.validatePass, trigger: "blur" },
            ],
            placeholder: this.$t("base.placeholder.confirmPwd"),
          },
        ],
      },
      codeTypeArray: [
        {
          label: "任意字符",
          value: 1,
        },
        {
          label: "字母+数字混和",
          value: 2,
        },
        {
          label: "大写字母+小写字母+数字混合",
          value: 3,
        },
      ],
      resetForm: {
        againPass: "",
        oldpass: "",
        pass: "",
        // newPassword: "",
        // confirmPassword: "",
      },
      searchParams: {},
      dialogVisible: false,
      transferShow: false,
      loading: true,
      type: "",
      account: {},
      tableData: Object.freeze([]),

      checkedAccounts: [],
      page: {
        currentPage: 1,
        total: 0,
        pageSize: utils.Cache.get("CURRENT_PAGESIZE") || 10,
      },
      option: tableOption(this),
      types: "",
      statusOptions: [
        {
          label: "启用",
          value: 1,
        },
        {
          label: "禁用",
          value: 2,
        },
        {
          label: "锁定",
          value: 3,
        },
      ],
      accountTypeDisabled: false,
      subLoading: false,
    };
  },
  mounted() {
    this.refreshChange(this.page);
    this.getSyConfig();
  },
  methods: {
    savePeopleInfo(params) {
      this.subLoading = true;
      let url = api.account.accountAdd;
      if (params.id) {
        // 编辑
        url = api.account.accountUpdate;
      }
      this.$fetch(url, {
        ...params,
        status: 1,
      }).then((res) => {
        this.subLoading = false;
        if (res && res.success) {
          this.getList(this.page);
          this.handleCloseAccountPanel();
          this.$message.success(params.id ? "编辑成功" : "新增成功");
        } else {
          this.$message.error(res.msgContent);
        }
      });
    },
    handleCloseAccountPanel() {
      this.$refs.refAccountPanel.handleRestForm();
      this.showAccountPanel = false;
      // this.$nextTick(() => {
      this.pageStates = "view";
      // });
      // this.$nextTick(() => {
      //   this.$refs.refAccountPanel.$refs.personTable.templateRadio = '';
      // });
    },
    handleSaveAccountPanel() {
      this.$refs.refAccountPanel.submit();
    },
    validatePwd(rule, value, callback) {
      let reg = "";
      if (this.codeType == 2) {
        // 数字+任意英文
        reg = new RegExp("^((?=.*\\d)(?=.*[A-Za-z]))[0-9a-zA-Z]*$");
      } else if (this.codeType == 3) {
        //数字+英文(大写+小写)
        reg = new RegExp("^((?=.*\\d)(?=.*[a-z])(?=.*[A-Z]))[0-9a-zA-Z]*$");
        // ^((?=.*\\d)(?=.*[a-z])(?=.*[A-Z]))[0-9a-zA-Z]*$
      } else {
        //任意密码
        callback();
        return;
      }
      if (!reg.test(value)) {
        callback(new Error("密码格式为:" + this.codeTypeArray[this.codeType - 1].label));
      } else {
        callback();
      }
    },
    validatePass(rule, value, callback) {
      if (value === "") {
        callback(new Error(this.$t("base.message.againPwd")));
      } else if (value !== this.resetForm.pass) {
        callback(new Error(this.$t("base.message.diffPwd")));
      } else {
        callback();
      }
    },
    handleClosePanel() {
      this.subLoading = false;
      this.showAuthPanel = false;
    },
    // 打开关联账户组面板
    handleSet(row) {
      this.$refs.transferDialog.open(row.accountNumber);
    },
    handleSave() {
      let chooseIds = [];
      let selectArray = this.$refs.refGroupTrans.selectedList;
      if (selectArray.length) {
        selectArray
          .filter((item) => item.checked === true)
          .forEach((item) => {
            chooseIds.push(item.code);
          });
      }
      this.subLoading = true;
      let params = {
        authGroupCodeList: chooseIds,
        accountNumber: this.$refs.refGroupTrans.accountNumber,
      };
      this.$fetch(api.group.updateAccountAuthGroup, params).then((res) => {
        this.subLoading = false;
        if (res.success) {
          this.$message.success("配置设备权限组成功");
          // this.$emit("refreshData")
          this.handleClosePanel();
        } else {
          this.$message.error(res.msgContent);
        }
      });
    },
    statusFormatter(data) {
      switch (data.status * 1) {
        case 1:
          return "在职";
        case 2:
          return "离职";
        case 4:
          return "未知";
        default:
          return data.status;
      }
    },
    getImgPath(item) {
      return item ? Bus.imgPath(item) : "";
    },
    handleSearchReset() {
      this.getResetList();
      this.types = 1;
    },
    getResetList() {
      const self = this;
      this.$fetch(
        api.account.queryAccouts,
        Object.assign({
          pageNo: 1,
          pageSize: 10,
        })
      ).then((response) => {
        if (!response.success) {
          self.$message({
            message: response.msgContent,
            type: "error",
            duration: 2000,
          });
          return;
        }
        self.tableData = response.returnObj
          ? Object.freeze([...response.returnObj.list])
          : [];
        self.page.total = response.returnObj ? response.returnObj.total : 0;
        self.page.currentPage = 1;
        self.page.pageSize = 10;
        self.$refs.crud.selectClear();
      });
    },
    onSubmitPwd() {
      let params = {
        accountNumber: this.accountNumber,
        newPassword: sha256.SHA256(this.resetForm.pass),
        confirmPassword: sha256.SHA256(this.resetForm.againPass),
      };
      if (params.accountNumber === this.resetForm.pass) {
        this.$message({
          message: "密码不能和账户名一致，请重置！",
          type: "error",
          duration: 2000,
        });
        this.dialogVisible = false;
      } else {
        // console.log(params.accountNumber, this.resetForm.pass, "ff");
        this.$fetch(api.account.editPassWord, params).then((res) => {
          if (!res.success) {
            // this.$message.error(res.msgContent)
            this.$message({
              message: res.msgContent,
              type: "error",
              duration: 2000,
            });
            return;
          }
          // this.$message.success("密码重置成功")
          this.$message({
            message: "密码重置成功",
            type: "success",
            duration: 2000,
          });
          this.dialogVisible = false;
        });
      }
    },
    getList(page) {
      const self = this;
      const $form = "";
      const params = {};
      if (this.types === 3) {
        params.accountNumber = this.searchParams.accountNumber;
        params.nickName = this.searchParams.nickName;
        params.accountType = this.searchParams.accountType;
        params.status = this.searchParams.status;
        params.accountGroupName = this.searchParams.role;
      } else {
        params.accountNumber = "";
        params.nickName = "";
        params.status = "";
      }
      const loading = this.$loading({
        lock: true,
        text: "请求中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });

      this.$fetch(
        api.account.queryAccouts,
        Object.assign(
          {
            pageNo: page.currentPage,
            pageSize: page.pageSize,
          },
          params
        )
      ).then((response) => {
        setTimeout(() => {
          loading.close();
        }, 500);
        if (!response.success) {
          // self.$message.error(response.msgContent)
          self.$message({
            message: response.msgContent,
            type: "error",
            duration: 2000,
          });
          return;
        }
        self.tableData = response.returnObj
          ? Object.freeze([...response.returnObj.list])
          : [];
        self.page.total = response.returnObj ? response.returnObj.total : 0;
        self.$refs.crud.selectClear();
      });
    },
    refreshChange(page) {
      this.getList(page);
    },
    handleCurrentChange(val) {
      this.page.currentPage = val;
      this.refreshChange(this.page);
    },
    handleSizeChange(val) {
      this.page.currentPage = 1;
      this.page.pageSize = val;
      this.refreshChange(this.page);
    },
    handleSearchChange(param) {
      this.page.currentPage = 1;
      this.types = 3;
      this.searchParams = Object.assign({}, param);
      this.getList(this.page);
    },
    //新增账户
    handleAddAccount() {
      this.showAccountPanel = true;
      this.pageStates = "add";
      this.$nextTick(() => {
        this.$refs.refAccountPanel.$refs.refForm.clearValidate();
        this.$refs.refAccountPanel.getPersonList()
      });
    },
    handleView(row, index) {
      this.pageStates = "view";
      this.showAccountPanel = true;
      this.$refs.refAccountPanel.handleSetForm(row);
    },
    handleEdit(row, index) {
      this.pageStates = "edit";
      this.showAccountPanel = true;
      this.isEditAccoutType = row.accountType === '1';
      this.$refs.refAccountPanel.handleSetForm(row);
      this.$refs.refAccountPanel.getPersonList()
    },
    handleDel(row) {
      const params = {
        accountNumberList: [row.accountNumber],
      };
      this.$confirm("您确定删除该账户吗?", "删除确认", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$fetch(api.account.accountDel, params).then((response) => {
          // this.tableData.splice(index, 1)
          if (response && response.success) {
            this.$message({
              message: "删除成功",
              type: "success",
              duration: 2000,
            });
          } else {
            this.$message({
              message: response.msgContent,
              type: "error",
              duration: 2000,
            });
          }
          this.getResetList();
        });
      });
    },
    handelDelAccounts() {
      if (this.checkedAccounts.length === 0) {
        this.$message({
          type: "warning",
          duration: 2000,
          message: "请选择你要删除的账户",
        });
        return;
      }
      const params = {
        accountNumberList: this.checkedAccounts,
      };
      this.$confirm("您确定删除这些账户吗?", "确认", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$fetch(api.account.accountDel, params).then((response) => {
            if (!response.success) {
              this.$message({
                message: response.msgContent,
                type: "error",
                duration: 2000,
              });
              return;
            }
            this.$message({
              message: "删除成功",
              type: "success",
              duration: 2000,
            });
            this.getResetList();
          });
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    unlock(row) {
      this.$confirm("确定要解锁此账户吗", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          const params = {
            accountGroupList: row.accountGroupList,
            accountNumber: row.accountNumber,
            desc: row.desc,
            personnelCode: row.personnelCode,
            status: 1,
          };
          this.$fetch(api.account.accountUpdateStatus, params).then((res) => {
            if (res.success) {
              this.$message({
                showClose: false,
                message: "账户解锁成功",
                type: "success",
                duration: 2000,
              });
              this.getList(this.page);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "success",
            message: "取消成功！",
            duration: 2000,
          });
        });
    },
    handleUpdateStatus(row) {
      this.$confirm(`确定要${row.status === 1 ? "启用" : "禁用"}此账户吗`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          const params = {
            accountGroupList: row.accountGroupList,
            accountNumber: row.accountNumber,
            desc: row.desc,
            personnelCode: row.personnelCode,
            status: row.status,
          };
          this.$fetch(api.account.accountUpdateStatus, params).then((res) => {
            if (res.success) {
              this.$message({
                showClose: false,
                message: `账户${row.status === 1 ? "启用" : "禁用"}成功`,
                type: "success",
                duration: 2000,
              });
              this.getList(this.page);
            }
          });
        })
        .catch(() => {
          this.getList(this.page);
          // console.log("取消操作");
        });
    },
    handleSelectionChange(items) {
      this.checkedAccounts = items.map((item) => {
        return item.accountNumber;
      });
    },
    getSyConfig() {
      let params = {
        cfgCode: "PASSWORD_FORMAT,PASSWORD_LENGTH",
        pageNum: 1,
        pageSize: 10,
      };
      this.$fetch(this.$api.common.querySysConfig, params).then((res) => {
        if (res.success) {
          this.codeType = Number(res.returnObj.list[0].cfgValue); //3
          this.passOption.column[0].rules[1].max = Number(res.returnObj.list[1].cfgValue);
          this.passOption.column[0].rules[1].min = Number(res.returnObj.list[1].cfgValue);
          this.passOption.column[0].rules[1].message =
            "密码长度为" + this.passOption.column[0].rules[1].max + "位字符";
        }
        this.option.column[4].rules = this.passOption.column[0].rules;
      });
    },
    handleEditPwd(row) {
      this.accountNumber = row.accountNumber;
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.resetPass.resetForm();
      });
    },
  },
};
</script>
<style lang="scss">
@import "~@src/common/assets/style/mixin";

.el-select {
  width: 100%;
}
</style>
